import api from './api';

const BASE_URL = '/v4/production';

// Production Plants API functions
export const productionPlantsApi = {
  // Get all production plants
  getAllPlants: async () => {
    try {
      const response = await api.get(`${BASE_URL}/plants`);
      return response.data;
    } catch (error) {
      console.error('Error fetching production plants:', error);
      throw error;
    }
  },

  // Get single production plant
  getPlant: async (plantId) => {
    try {
      const response = await api.get(`${BASE_URL}/plants/${plantId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching production plant:', error);
      throw error;
    }
  },

  // Create new production plant
  createPlant: async (plantData) => {
    try {
      const response = await api.post(`${BASE_URL}/plants`, plantData);
      return response.data;
    } catch (error) {
      console.error('Error creating production plant:', error);
      throw error;
    }
  },

  // Update production plant
  updatePlant: async (plantId, plantData) => {
    try {
      const response = await api.put(`${BASE_URL}/plants/${plantId}`, plantData);
      return response.data;
    } catch (error) {
      console.error('Error updating production plant:', error);
      throw error;
    }
  },

  // Delete production plant
  deletePlant: async (plantId) => {
    try {
      const response = await api.delete(`${BASE_URL}/plants/${plantId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting production plant:', error);
      throw error;
    }
  },

  // Get sections for a plant
  getPlantSections: async (plantId) => {
    try {
      const response = await api.get(`${BASE_URL}/plants/${plantId}/sections`);
      return response.data;
    } catch (error) {
      console.error('Error fetching plant sections:', error);
      throw error;
    }
  },

  // Create new section
  createSection: async (plantId, sectionData) => {
    try {
      const response = await api.post(`${BASE_URL}/plants/${plantId}/sections`, sectionData);
      return response.data;
    } catch (error) {
      console.error('Error creating section:', error);
      throw error;
    }
  },

  // Update section
  updateSection: async (sectionId, sectionData) => {
    try {
      const response = await api.put(`${BASE_URL}/sections/${sectionId}`, sectionData);
      return response.data;
    } catch (error) {
      console.error('Error updating section:', error);
      throw error;
    }
  },

  // Delete section
  deleteSection: async (sectionId) => {
    try {
      const response = await api.delete(`${BASE_URL}/sections/${sectionId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting section:', error);
      throw error;
    }
  },

  // Reorder sections
  reorderSections: async (plantId, sections) => {
    try {
      const response = await api.put(`${BASE_URL}/plants/${plantId}/sections/reorder`, { sections });
      return response.data;
    } catch (error) {
      console.error('Error reordering sections:', error);
      throw error;
    }
  },

  // ==================== PRODUCTION BATCH API FUNCTIONS ====================

  // Get all production batches
  getAllBatches: async (params = {}) => {
    try {
      const response = await api.get(`${BASE_URL}/batches`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching production batches:', error);
      throw error;
    }
  },

  // Get single production batch
  getBatch: async (batchId) => {
    try {
      const response = await api.get(`${BASE_URL}/batches/${batchId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching production batch:', error);
      throw error;
    }
  },

  // Create new production batch
  createBatch: async (batchData) => {
    try {
      const response = await api.post(`${BASE_URL}/batches`, batchData);
      return response.data;
    } catch (error) {
      console.error('Error creating production batch:', error);
      throw error;
    }
  },

  // Update batch status
  updateBatchStatus: async (batchId, statusData) => {
    try {
      const response = await api.put(`${BASE_URL}/batches/${batchId}/status`, statusData);
      return response.data;
    } catch (error) {
      console.error('Error updating batch status:', error);
      throw error;
    }
  },

  // Add items to existing batch
  addItemsToBatch: async (batchId, itemsData) => {
    try {
      const response = await api.post(`${BASE_URL}/batches/${batchId}/items`, itemsData);
      return response.data;
    } catch (error) {
      console.error('Error adding items to batch:', error);
      throw error;
    }
  },

  // ==================== INVENTORY API FUNCTIONS ====================

  // Get plant inventory overview
  getPlantInventory: async (plantId) => {
    try {
      const response = await api.get(`${BASE_URL}/plants/${plantId}/inventory`);
      return response.data;
    } catch (error) {
      console.error('Error fetching plant inventory:', error);
      throw error;
    }
  },

  // Get inventory for a specific section
  getSectionInventory: async (plantId, sectionId) => {
    try {
      const response = await api.get(`${BASE_URL}/plants/${plantId}/sections/${sectionId}/inventory`);
      return response.data;
    } catch (error) {
      console.error('Error fetching section inventory:', error);
      throw error;
    }
  },

  // Get inventory for a specific batch
  getBatchInventory: async (plantId, batchId) => {
    try {
      const response = await api.get(`${BASE_URL}/plants/${plantId}/batches/${batchId}/inventory`);
      return response.data;
    } catch (error) {
      console.error('Error fetching batch inventory:', error);
      throw error;
    }
  },

  // Get all batches for a plant
  getPlantBatches: async (plantId) => {
    try {
      const response = await api.get(`${BASE_URL}/plants/${plantId}/batches`);
      return response.data;
    } catch (error) {
      console.error('Error fetching plant batches:', error);
      throw error;
    }
  },

  // Update inventory quantity
  updateInventory: async (plantId, inventoryData) => {
    try {
      const response = await api.put(`${BASE_URL}/plants/${plantId}/inventory`, inventoryData);
      return response.data;
    } catch (error) {
      console.error('Error updating inventory:', error);
      throw error;
    }
  }
};

export default productionPlantsApi; 